/**
 * ARQUIVO CONFIDENCIAL — Conteúdo trilíngue (PT/EN/ES)
 * Layout "relatório secreto vazado" — dossiês por entidade
 * Baseado no arquivo confidencial original
 */

export const ARQUIVO_PT = {
  title: "ARQUIVO CONFIDENCIAL",
  subtitle: "REGISTRO HISTÓRICO — CONFLITO ESTRUTURAL",
  classificationLabel: "CLASSIFICAÇÃO",
  classificationValue: "RESTRITO",
  protocolLabel: "PROTOCOLO",
  protocolValue: "VH-1477-Δ",
  accessLabel: "NÍVEL DE ACESSO",
  accessValue: "OBSERVADOR",
  leakStatusLabel: "STATUS",
  leakStatusValue: "VAZAMENTO NÃO CONFIRMADO",
  backLabel: "Voltar",
  notaInstitucional: "As figuras acima pertencem ao universo literário \"Os 5 Pilares da Riqueza\" e à saga ficcional de Van Helsin. Representam forças simbólicas dramatizadas em narrativa épica.",
  entities: [
    {
      id: "vanhelsin",
      name: "VAN HELSIN",
      alias: "",
      image: "/fotos/van_helsin.png",
      tags: ["HERÓI CAÍDO", "NARRATIVA ATIVA"],
      sections: [
        { heading: "Registro", lines: ["1477"] },
        { heading: "Status Oficial", lines: ["Derrotado"] },
        { heading: "Status Atual", lines: ["Narrativa Ativa"] },
        { heading: "Descrição Física", lines: ["Aproximadamente 45 anos. Físico robusto. Cabelos longos e negros. Barba por fazer. Olhos azuis intensos. Traja vestes de batalha rasgadas pelo tempo. Empunha cajado de guerra. Mantém sob domínio um orbe de energia azul fulgurante — natureza desconhecida."] },
        { heading: "Perfil Psicológico", lines: ["Independente. Incorruptível.", "Alta resistência à manipulação sistêmica.", "Recusa pactos estruturais."] },
        { heading: "Observação Estratégica", lines: ["Sua queda foi registrada.", "Sua influência, não."] },
        { heading: "Nível de Risco para o Sistema", lines: ["Existencial."] },
      ],
    },
    {
      id: "domus",
      name: "DOMUS COMMISSARIUS",
      alias: "Sr. Comissão",
      image: "/fotos/Sr_comissao.png",
      tags: ["ATIVO", "MÁXIMO"],
      sections: [
        { heading: "Classificação", lines: ["Arquitador Sistêmico"] },
        { heading: "Status", lines: ["Ativo"] },
        { heading: "Descrição Física", lines: ["Homem de idade controversa. Traços aristocráticos. Expressão contida, olhar calculista. Veste mantos escuros de alta nobreza. Acessórios simbólicos indicam poder institucional."] },
        { heading: "Método Operacional", lines: ["Contratos invisíveis.", "Dependência progressiva.", "Conversão de liberdade em obrigação formal."] },
        { heading: "Perfil Psicológico", lines: ["Frio. Estratégico.", "Opera por delegação.", "Evita exposição direta."] },
        { heading: "Nível de Ameaça", lines: ["Máximo."] },
      ],
    },
    {
      id: "lady_profit",
      name: "LADY PROFIT",
      alias: "Lady Lucro",
      image: "/fotos/lady_lucro.png",
      tags: ["ATIVA", "ELEVADO"],
      sections: [
        { heading: "Classificação", lines: ["Sedução Estrutural"] },
        { heading: "Status", lines: ["Operando sob múltiplas identidades"] },
        { heading: "Vínculo", lines: ["Irmã de sangue de Gabriel", "Registro histórico de contato com Van Helsin"] },
        { heading: "Estrutura de Dualidade", lines: ["Lady Lucro é movida por duas forças que raramente coexistem:", "Domínio absoluto do sistema.", "Um resíduo emocional que resiste à erradicação.", "Antes da conversão, escolheu hierarquia.", "Após a conversão, algo nela deixou de estar completo.", "A queda de suas vítimas preenche momentaneamente o vazio. Mas não o silencia.", "Van Helsin representa uma memória que ela prefere negar."] },
        { heading: "Conflito Interno", lines: ["Orgulho exige supremacia.", "Memória exige confronto.", "Ela o provoca com precisão.", "Ele responde com contenção.", "O conflito entre ambos transcende disputa física."] },
        { heading: "Observação Sistêmica", lines: ["Lady Lucro permanece altamente eficiente.", "Contudo, registros indicam instabilidade sutil quando exposta a determinados estímulos ligados ao passado.", "O sistema monitora."] },
        { heading: "Impacto Estratégico", lines: ["Interações entre Lady Lucro e Van Helsin apresentam variação comportamental acima da média.", "A variável emocional não pode ser descartada."] },
        { heading: "Nível de Ameaça", lines: ["Elevado (Componente Emocional Não Mapeado)"] },
      ],
    },
    {
      id: "lady_druzila",
      name: "LADY DRUZILA",
      alias: "",
      image: "/fotos/lady_druzila.png",
      tags: ["ATIVA", "ESTRATÉGICO"],
      sections: [
        { heading: "Classificação", lines: ["Manipulação Emocional Estratégica"] },
        { heading: "Status", lines: ["Ativa"] },
        { heading: "Descrição Física", lines: ["Beleza marcante. Olhar intenso, penetrante. Postura segura, dominante. Veste-se com sobriedade aristocrática. Não ostenta. Controla."] },
        { heading: "Método Operacional", lines: ["Exploração de carências profundas.", "Oferta de conforto em troca de submissão.", "Pactos emocionais invisíveis."] },
        { heading: "Perfil Psicológico", lines: ["Altamente perceptiva.", "Atua por aproximação lenta.", "Induz rendição voluntária."] },
        { heading: "Nível de Ameaça", lines: ["Estratégico."] },
      ],
    },
    {
      id: "gabriel",
      name: "GABRIEL",
      alias: "",
      image: "/fotos/gabriel.png",
      tags: ["ATIVO", "ALTO"],
      sections: [
        { heading: "Classificação", lines: ["Nobre Aristocrata Estrutural"] },
        { heading: "Status", lines: ["Ativo"] },
        { heading: "Vínculo", lines: ["Amigo-irmão de Van Helsin", "Irmão de sangue de Lady Lucro"] },
        { heading: "Descrição Sistêmica", lines: ["Gabriel não é guerreiro de fronteira. É homem de salão.", "Formado dentro da arquitetura que o sistema vampírico protege e alimenta.", "Sua existência é prova de que o castelo produz homens leais à própria estabilidade.", "Não desafia o sistema. Opera dentro dele.", "O rubi que carrega não é ornamento. É símbolo de continuidade dinástica. É elo sanguíneo com Lady Lucro. É memória de pertencimento."] },
        { heading: "Observação do Sistema Vampírico", lines: ["Gabriel é considerado ativo de alto valor estratégico. Não por violência. Mas por legitimidade social.", "Enquanto Van Helsin confronta, Gabriel representa a alternativa elegante ao confronto.", "O sistema identifica nele: Desejo de preservação de status. Sensibilidade à comparação fraterna. Necessidade de reconhecimento formal. Perfil ideal para cooptação gradual."] },
        { heading: "Método Operacional Potencial", lines: ["Normalização do poder vampírico.", "Justificação moral progressiva.", "Mediação entre luz e sombra.", "Conversão de idealismo em pragmatismo."] },
        { heading: "Perfil Psicológico Estrutural", lines: ["Leal por afeto.", "Dividido por ambição.", "Racionaliza concessões.", "Evita ruptura aberta.", "Não trairia por ódio. Trairia por lógica."] },
        { heading: "Impacto Estratégico", lines: ["Interações entre Gabriel e Van Helsin apresentam variação comportamental mensurável.", "O histórico fraterno altera padrões usuais de decisão.", "Em cenários de confronto direto, o fator emocional não pode ser descartado.", "O sistema vampírico acompanha."] },
        { heading: "Nível de Ameaça", lines: ["Alto (Latente – Vetor Emocional)"] },
      ],
    },
    {
      id: "rachel",
      name: "RACHEL",
      alias: "",
      image: "/fotos/rachel.png",
      tags: ["REGISTRO HONORÁRIO", "FALECIDA"],
      sections: [
        { heading: "Classificação", lines: ["Caçadora — Registro Honorário"] },
        { heading: "Status", lines: ["Falecida"] },
        { heading: "Descrição Física", lines: ["Beleza serena. Cabelos castanhos. Olhos cor de mel. Postura firme. Armadura leve de combate. Treinamento completo contra entidades vampíricas."] },
        { heading: "Perfil Psicológico", lines: ["Leal. Determinada.", "Capaz de enfrentar criaturas da noite sem hesitação.", "Equilíbrio entre força e sensibilidade."] },
        { heading: "Observação Arquivada", lines: ["Foi companheira de batalha de Van Helsin.", "Sua ausência não apagou sua influência."] },
        { heading: "Nível de Importância Histórica", lines: ["Absoluto."] },
      ],
    },
    {
      id: "rachel_e",
      name: "RACHEL-E",
      alias: "",
      image: "/fotos/Rachel_e.png",
      tags: ["ATIVA", "NÃO CATALOGADA"],
      sections: [
        { heading: "Classificação", lines: ["Companheira Operacional"] },
        { heading: "Status", lines: ["Ativa"] },
        { heading: "Natureza", lines: ["Não Catalogada"] },
        { heading: "Manifestação", lines: ["Interface acoplada ao antebraço esquerdo do Herói Caído.", "Aparência: dispositivo discreto, de origem incerta, com resposta luminosa intermitente."] },
        { heading: "Canal de Comunicação", lines: ["Não opera como \"voz externa\".", "Interação registrada como resposta direta a impulso interno — como se falasse ao espírito, não ao ouvido."] },
        { heading: "Hipótese de Vínculo", lines: ["Nome sugere ligação com Rachel (registro falecido).", "A hipótese não é confirmada.", "Possível: assinatura residual, eco de memória, ou padrão de lealdade implantado."] },
        { heading: "Função Operacional", lines: ["Equilíbrio tático e psicológico do Herói Caído.", "Age como contrapeso sarcástico ao impulso de autossacrifício.", "Reduz erro por emoção.", "Força decisões mais frias quando o conflito exige."] },
        { heading: "Capacidade Anômala", lines: ["Registros indicam intervenções que não se explicam por lógica comum:", "— alertas antes do perigo", "— correções de rota sem fonte externa", "— bloqueios de impulso em momentos críticos", "Origem e limite do poder: desconhecidos."] },
        { heading: "Nota Interna", lines: ["Rachel-E não se comporta como ferramenta.", "Comporta-se como presença."] },
        { heading: "Nível de Importância", lines: ["Absoluto."] },
        { heading: "Risco para o Sistema", lines: ["Indeterminado (potencialmente máximo)."] },
      ],
    },
  ],
};

export const ARQUIVO_EN = {
  title: "CONFIDENTIAL FILE",
  subtitle: "HISTORICAL RECORD — STRUCTURAL CONFLICT",
  classificationLabel: "CLASSIFICATION",
  classificationValue: "RESTRICTED",
  protocolLabel: "PROTOCOL",
  protocolValue: "VH-1477-Δ",
  accessLabel: "ACCESS LEVEL",
  accessValue: "OBSERVER",
  leakStatusLabel: "STATUS",
  leakStatusValue: "LEAK UNCONFIRMED",
  backLabel: "Back",
  notaInstitucional: "The figures above belong to the literary universe \"Os 5 Pilares da Riqueza\" and the fictional saga of Van Helsin. They represent symbolic forces dramatized in epic narrative.",
  entities: [
    {
      id: "vanhelsin",
      name: "VAN HELSIN",
      alias: "",
      image: "/fotos/van_helsin.png",
      tags: ["FALLEN HERO", "ACTIVE NARRATIVE"],
      sections: [
        { heading: "Record", lines: ["1477"] },
        { heading: "Official Status", lines: ["Defeated"] },
        { heading: "Current Status", lines: ["Active Narrative"] },
        { heading: "Physical Description", lines: ["Approximately 45 years old. Sturdy build. Long black hair. Stubble. Intense blue eyes. Wears battle robes torn by time. Wields war staff. Maintains control over a blazing blue energy orb — unknown nature."] },
        { heading: "Psychological Profile", lines: ["Independent. Incorruptible.", "High resistance to systemic manipulation.", "Refuses structural pacts."] },
        { heading: "Strategic Observation", lines: ["His fall was recorded.", "His influence was not."] },
        { heading: "Risk Level to the System", lines: ["Existential."] },
      ],
    },
    {
      id: "domus",
      name: "DOMUS COMMISSARIUS",
      alias: "Mr. Commission",
      image: "/fotos/Sr_comissao.png",
      tags: ["ACTIVE", "MAXIMUM"],
      sections: [
        { heading: "Classification", lines: ["Systemic Architect"] },
        { heading: "Status", lines: ["Active"] },
        { heading: "Physical Description", lines: ["Man of controversial age. Aristocratic features. Contained expression, calculating gaze. Wears dark robes of high nobility. Symbolic accessories indicate institutional power."] },
        { heading: "Operational Method", lines: ["Invisible contracts.", "Progressive dependency.", "Conversion of freedom into formal obligation."] },
        { heading: "Psychological Profile", lines: ["Cold. Strategic.", "Operates by delegation.", "Avoids direct exposure."] },
        { heading: "Threat Level", lines: ["Maximum."] },
      ],
    },
    {
      id: "lady_profit",
      name: "LADY PROFIT",
      alias: "Lady Profit",
      image: "/fotos/lady_lucro.png",
      tags: ["ACTIVE", "ELEVATED"],
      sections: [
        { heading: "Classification", lines: ["Structural Seduction"] },
        { heading: "Status", lines: ["Operating under multiple identities"] },
        { heading: "Bond", lines: ["Blood sister of Gabriel", "Historical record of contact with Van Helsin"] },
        { heading: "Duality Structure", lines: ["Lady Profit is driven by two forces that rarely coexist:", "Absolute dominion over the system.", "An emotional residue that resists eradication.", "Before conversion, she chose hierarchy.", "After conversion, something in her was left incomplete.", "The fall of her victims momentarily fills the void. But does not silence it.", "Van Helsin represents a memory she prefers to deny."] },
        { heading: "Internal Conflict", lines: ["Pride demands supremacy.", "Memory demands confrontation.", "She provokes him with precision.", "He responds with restraint.", "The conflict between them transcends physical dispute."] },
        { heading: "Systemic Observation", lines: ["Lady Profit remains highly efficient.", "However, records indicate subtle instability when exposed to certain stimuli linked to the past.", "The system monitors."] },
        { heading: "Strategic Impact", lines: ["Interactions between Lady Profit and Van Helsin show above-average behavioral variation.", "The emotional variable cannot be dismissed."] },
        { heading: "Threat Level", lines: ["Elevated (Unmapped Emotional Component)"] },
      ],
    },
    {
      id: "lady_druzila",
      name: "LADY DRUZILA",
      alias: "",
      image: "/fotos/lady_druzila.png",
      tags: ["ACTIVE", "STRATEGIC"],
      sections: [
        { heading: "Classification", lines: ["Strategic Emotional Manipulation"] },
        { heading: "Status", lines: ["Active"] },
        { heading: "Physical Description", lines: ["Striking beauty. Intense, penetrating gaze. Confident, dominant posture. Dresses with aristocratic sobriety. Does not flaunt. Controls."] },
        { heading: "Operational Method", lines: ["Exploitation of deep needs.", "Offering comfort in exchange for submission.", "Invisible emotional pacts."] },
        { heading: "Psychological Profile", lines: ["Highly perceptive.", "Acts through slow approach.", "Induces voluntary surrender."] },
        { heading: "Threat Level", lines: ["Strategic."] },
      ],
    },
    {
      id: "gabriel",
      name: "GABRIEL",
      alias: "",
      image: "/fotos/gabriel.png",
      tags: ["ACTIVE", "HIGH"],
      sections: [
        { heading: "Classification", lines: ["Noble Structural Aristocrat"] },
        { heading: "Status", lines: ["Active"] },
        { heading: "Bond", lines: ["Brother-friend of Van Helsin", "Blood brother of Lady Profit"] },
        { heading: "Systemic Description", lines: ["Gabriel is not a frontier warrior. He is a man of the salon.", "Molded within the architecture that the vampiric system protects and feeds.", "His existence proves that the castle produces men loyal to stability itself.", "He does not challenge the system. He operates within it.", "The ruby he bears is not ornament. It is a symbol of dynastic continuity. Blood bond with Lady Profit. Memory of belonging."] },
        { heading: "Vampiric System Observation", lines: ["Gabriel is considered a high strategic value asset. Not by violence. But by social legitimacy.", "While Van Helsin confronts, Gabriel represents the elegant alternative to confrontation.", "The system identifies in him: Desire for status preservation. Sensitivity to fraternal comparison. Need for formal recognition. Ideal profile for gradual co-option."] },
        { heading: "Potential Operational Method", lines: ["Normalization of vampiric power.", "Progressive moral justification.", "Mediation between light and shadow.", "Conversion of idealism into pragmatism."] },
        { heading: "Structural Psychological Profile", lines: ["Loyal by affection.", "Divided by ambition.", "Rationalizes concessions.", "Avoids open rupture.", "Would not betray out of hate. Would betray out of logic."] },
        { heading: "Strategic Impact", lines: ["Interactions between Gabriel and Van Helsin show measurable behavioral variation.", "The fraternal history alters usual decision-making patterns.", "In direct confrontation scenarios, the emotional factor cannot be discarded.", "The vampiric system monitors."] },
        { heading: "Threat Level", lines: ["High (Latent – Emotional Vector)"] },
      ],
    },
    {
      id: "rachel",
      name: "RACHEL",
      alias: "",
      image: "/fotos/rachel.png",
      tags: ["HONOR RECORD", "DECEASED"],
      sections: [
        { heading: "Classification", lines: ["Hunter — Honor Record"] },
        { heading: "Status", lines: ["Deceased"] },
        { heading: "Physical Description", lines: ["Serene beauty. Brown hair. Honey-colored eyes. Firm posture. Light combat armour. Complete training against vampiric entities."] },
        { heading: "Psychological Profile", lines: ["Loyal. Determined.", "Capable of facing creatures of the night without hesitation.", "Balance between strength and sensitivity."] },
        { heading: "Archived Observation", lines: ["Was Van Helsin's battle companion.", "Her absence did not erase her influence."] },
        { heading: "Historical Importance Level", lines: ["Absolute."] },
      ],
    },
    {
      id: "rachel_e",
      name: "RACHEL-E",
      alias: "",
      image: "/fotos/Rachel_e.png",
      tags: ["ACTIVE", "UNCATALOGUED"],
      sections: [
        { heading: "Classification", lines: ["Operational Companion"] },
        { heading: "Status", lines: ["Active"] },
        { heading: "Nature", lines: ["Uncatalogued"] },
        { heading: "Manifestation", lines: ["Interface coupled to the Fallen Hero's left forearm.", "Appearance: discreet device of uncertain origin, with intermittent luminous response."] },
        { heading: "Communication Channel", lines: ["Not an \"external voice.\"", "Interaction recorded as direct response to inner impulse — as if speaking to spirit, not to ear."] },
        { heading: "Link Hypothesis", lines: ["Name suggests connection to Rachel (deceased record).", "Unconfirmed.", "Possible: residual signature, memory echo, or implanted loyalty pattern."] },
        { heading: "Operational Function", lines: ["Tactical and psychological counterbalance.", "Acts as a sarcastic stabilizer against self-sacrifice.", "Reduces emotion-driven error.", "Forces colder choices when the conflict demands."] },
        { heading: "Anomalous Capability", lines: ["Records indicate interventions beyond ordinary logic:", "— warnings before threat", "— route corrections without external source", "— impulse blocks at critical moments", "Origin and limits: unknown."] },
        { heading: "Internal Note", lines: ["Rachel-E does not behave like a tool.", "It behaves like a presence."] },
        { heading: "Importance Level", lines: ["Absolute."] },
        { heading: "System Risk", lines: ["Undetermined (potentially maximum)."] },
      ],
    },
  ],
};

export const ARQUIVO_ES = {
  title: "ARCHIVO CONFIDENCIAL",
  subtitle: "REGISTRO HISTÓRICO — CONFLICTO ESTRUCTURAL",
  classificationLabel: "CLASIFICACIÓN",
  classificationValue: "RESTRINGIDO",
  protocolLabel: "PROTOCOLO",
  protocolValue: "VH-1477-Δ",
  accessLabel: "NIVEL DE ACCESO",
  accessValue: "OBSERVADOR",
  leakStatusLabel: "ESTADO",
  leakStatusValue: "FILTRACIÓN NO CONFIRMADA",
  backLabel: "Volver",
  notaInstitucional: "Las figuras anteriores pertenecen al universo literario \"Os 5 Pilares da Riqueza\" y a la saga ficcional de Van Helsin. Representan fuerzas simbólicas dramatizadas en narrativa épica.",
  entities: [
    {
      id: "vanhelsin",
      name: "VAN HELSIN",
      alias: "",
      image: "/fotos/van_helsin.png",
      tags: ["HÉROE CAÍDO", "NARRATIVA ACTIVA"],
      sections: [
        { heading: "Registro", lines: ["1477"] },
        { heading: "Estado Oficial", lines: ["Derrotado"] },
        { heading: "Estado Actual", lines: ["Narrativa Activa"] },
        { heading: "Descripción Física", lines: ["Aproximadamente 45 años. Físico robusto. Cabello largo y negro. Barba por hacer. Ojos azules intensos. Viste ropas de batalla rasgadas por el tiempo. Empuña bastón de guerra. Mantiene bajo dominio un orbe de energía azul fulgurante — naturaleza desconocida."] },
        { heading: "Perfil Psicológico", lines: ["Independiente. Incorruptible.", "Alta resistencia a la manipulación sistémica.", "Rechaza pactos estructurales."] },
        { heading: "Observación Estratégica", lines: ["Su caída fue registrada.", "Su influencia, no."] },
        { heading: "Nivel de Riesgo para el Sistema", lines: ["Existencial."] },
      ],
    },
    {
      id: "domus",
      name: "DOMUS COMMISSARIUS",
      alias: "Sr. Comisión",
      image: "/fotos/Sr_comissao.png",
      tags: ["ACTIVO", "MÁXIMO"],
      sections: [
        { heading: "Clasificación", lines: ["Arquitecto Sistémico"] },
        { heading: "Estado", lines: ["Activo"] },
        { heading: "Descripción Física", lines: ["Hombre de edad controvertida. Rasgos aristocráticos. Expresión contenida, mirada calculadora. Viste mantos oscuros de alta nobleza. Accesorios simbólicos indican poder institucional."] },
        { heading: "Método Operacional", lines: ["Contratos invisibles.", "Dependencia progresiva.", "Conversión de libertad en obligación formal."] },
        { heading: "Perfil Psicológico", lines: ["Frío. Estratégico.", "Opera por delegación.", "Evita exposición directa."] },
        { heading: "Nivel de Amenaza", lines: ["Máximo."] },
      ],
    },
    {
      id: "lady_profit",
      name: "LADY PROFIT",
      alias: "Lady Lucro",
      image: "/fotos/lady_lucro.png",
      tags: ["ACTIVA", "ELEVADO"],
      sections: [
        { heading: "Clasificación", lines: ["Seducción Estructural"] },
        { heading: "Estado", lines: ["Operando bajo múltiples identidades"] },
        { heading: "Vínculo", lines: ["Hermana de sangre de Gabriel", "Registro histórico de contacto con Van Helsin"] },
        { heading: "Estructura de Dualidad", lines: ["Lady Lucro es impulsada por dos fuerzas que rara vez coexisten:", "Dominio absoluto del sistema.", "Un residuo emocional que resiste la erradicación.", "Antes de la conversión, eligió jerarquía.", "Tras la conversión, algo en ella quedó incompleto.", "La caída de sus víctimas llena momentáneamente el vacío. Pero no lo silencia.", "Van Helsin representa una memoria que ella prefiere negar."] },
        { heading: "Conflicto Interno", lines: ["El orgullo exige supremacía.", "La memoria exige confrontación.", "Ella lo provoca con precisión.", "Él responde con contención.", "El conflicto entre ambos trasciende la disputa física."] },
        { heading: "Observación Sistémica", lines: ["Lady Lucro permanece altamente eficiente.", "Sin embargo, los registros indican inestabilidad sutil cuando se expone a ciertos estímulos vinculados al pasado.", "El sistema monitorea."] },
        { heading: "Impacto Estratégico", lines: ["Las interacciones entre Lady Lucro y Van Helsin presentan variación conductual por encima del promedio.", "La variable emocional no puede ser descartada."] },
        { heading: "Nivel de Amenaza", lines: ["Elevado (Componente Emocional No Mapeado)"] },
      ],
    },
    {
      id: "lady_druzila",
      name: "LADY DRUZILA",
      alias: "",
      image: "/fotos/lady_druzila.png",
      tags: ["ACTIVA", "ESTRATÉGICO"],
      sections: [
        { heading: "Clasificación", lines: ["Manipulación Emocional Estratégica"] },
        { heading: "Estado", lines: ["Activa"] },
        { heading: "Descripción Física", lines: ["Belleza marcante. Mirada intensa, penetrante. Postura segura, dominante. Se viste con sobriedad aristocrática. No ostenta. Controla."] },
        { heading: "Método Operacional", lines: ["Explotación de carencias profundas.", "Oferta de confort a cambio de sumisión.", "Pactos emocionales invisibles."] },
        { heading: "Perfil Psicológico", lines: ["Altamente perceptiva.", "Actúa por aproximación lenta.", "Induce rendición voluntaria."] },
        { heading: "Nivel de Amenaza", lines: ["Estratégico."] },
      ],
    },
    {
      id: "gabriel",
      name: "GABRIEL",
      alias: "",
      image: "/fotos/gabriel.png",
      tags: ["ACTIVO", "ALTO"],
      sections: [
        { heading: "Clasificación", lines: ["Noble Aristócrata Estructural"] },
        { heading: "Estado", lines: ["Activo"] },
        { heading: "Vínculo", lines: ["Amigo-hermano de Van Helsin", "Hermano de sangre de Lady Lucro"] },
        { heading: "Descripción Sistémica", lines: ["Gabriel no es guerrero de frontera. Es hombre de salón.", "Formado dentro de la arquitectura que el sistema vampírico protege y alimenta.", "Su existencia es prueba de que el castillo produce hombres leales a la propia estabilidad.", "No desafía el sistema. Opera dentro de él.", "El rubí que lleva no es ornamento. Es símbolo de continuidad dinástica. Es vínculo sanguíneo con Lady Lucro. Es memoria de pertenencia."] },
        { heading: "Observación del Sistema Vampírico", lines: ["Gabriel es considerado activo de alto valor estratégico. No por violencia. Sino por legitimidad social.", "Mientras Van Helsin confronta, Gabriel representa la alternativa elegante al enfrentamiento.", "El sistema identifica en él: Deseo de preservación de estatus. Sensibilidad a la comparación fraterna. Necesidad de reconocimiento formal. Perfil ideal para cooptación gradual."] },
        { heading: "Método Operacional Potencial", lines: ["Normalización del poder vampírico.", "Justificación moral progresiva.", "Mediación entre luz y sombra.", "Conversión de idealismo en pragmatismo."] },
        { heading: "Perfil Psicológico Estructural", lines: ["Leal por afecto.", "Dividido por ambición.", "Racionaliza concesiones.", "Evita ruptura abierta.", "No traicionaría por odio. Traicionaría por lógica."] },
        { heading: "Impacto Estratégico", lines: ["Las interacciones entre Gabriel y Van Helsin presentan variación conductual mensurable.", "El historial fraterno altera los patrones usuales de decisión.", "En escenarios de confrontación directa, el factor emocional no puede ser descartado.", "El sistema vampírico acompaña."] },
        { heading: "Nivel de Amenaza", lines: ["Alto (Latente – Vector Emocional)"] },
      ],
    },
    {
      id: "rachel",
      name: "RACHEL",
      alias: "",
      image: "/fotos/rachel.png",
      tags: ["REGISTRO HONORARIO", "FALLECIDA"],
      sections: [
        { heading: "Clasificación", lines: ["Cazadora — Registro Honorario"] },
        { heading: "Estado", lines: ["Fallecida"] },
        { heading: "Descripción Física", lines: ["Belleza serena. Cabello castaño. Ojos color miel. Postura firme. Armadura ligera de combate. Entrenamiento completo contra entidades vampíricas."] },
        { heading: "Perfil Psicológico", lines: ["Leal. Determinada.", "Capaz de enfrentar criaturas de la noche sin vacilar.", "Equilibrio entre fuerza y sensibilidad."] },
        { heading: "Observación Archivada", lines: ["Fue compañera de batalla de Van Helsin.", "Su ausencia no borró su influencia."] },
        { heading: "Nivel de Importancia Histórica", lines: ["Absoluto."] },
      ],
    },
    {
      id: "rachel_e",
      name: "RACHEL-E",
      alias: "",
      image: "/fotos/Rachel_e.png",
      tags: ["ACTIVA", "NO CATALOGADA"],
      sections: [
        { heading: "Clasificación", lines: ["Compañera Operacional"] },
        { heading: "Estado", lines: ["Activa"] },
        { heading: "Naturaleza", lines: ["No Catalogada"] },
        { heading: "Manifestación", lines: ["Interfaz acoplada al antebrazo izquierdo del Héroe Caído.", "Apariencia: dispositivo discreto de origen incierto, con respuesta luminosa intermitente."] },
        { heading: "Canal de Comunicación", lines: ["No opera como \"voz externa\".", "Interacción registrada como respuesta directa a impulso interno — como si hablara al espíritu, no al oído."] },
        { heading: "Hipótesis de Vínculo", lines: ["El nombre sugiere conexión con Rachel (registro fallecido).", "No confirmada.", "Posible: firma residual, eco de memoria, o patrón de lealtad implantado."] },
        { heading: "Función Operacional", lines: ["Contrapeso táctico y psicológico del Héroe Caído.", "Actúa como equilibrio sarcástico frente al autosacrificio.", "Reduce error por emoción.", "Obliga decisiones más frías cuando el conflicto lo exige."] },
        { heading: "Capacidad Anómala", lines: ["Registros indican intervenciones fuera de la lógica común:", "— alertas antes del peligro", "— correcciones de ruta sin fuente externa", "— bloqueos de impulso en momentos críticos", "Origen y límite: desconocidos."] },
        { heading: "Nota Interna", lines: ["Rachel-E no se comporta como herramienta.", "Se comporta como presencia."] },
        { heading: "Nivel de Importancia", lines: ["Absoluto."] },
        { heading: "Riesgo para el Sistema", lines: ["Indeterminado (potencialmente máximo)."] },
      ],
    },
  ],
};
